<template>
  <div class="denomination_modal_box">
    <b-modal
      ref="modal"
       :id="modalId"
      hide-footer
      centered
      title="面額即享券"
      modal-class="discount-modal"
    >
      <form>
        <div class="input-area">
          <div class="bouns single-input">
            <div class="d-flex input-head">
              <p class="input-name">折抵金額</p>
            </div>
            <div class="">
              <input
                v-model="enjoyDis"
                type="number"
                name="enjoybalance"
                class="discount-text-input disable-input"
                disabled
              />
            </div>
          </div>
        </div>

        <div slot="modal-footer" class="modal_footer">
          <div class="text-center">
            <b-btn class="hoverFill" @click="handleHide">
              取消
            </b-btn>
            <a class="btn hoverFill btn-secondary" target="_blank" @click="submit">
              確認
            </a>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';
export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      denomination: 500
    };
  },
  computed: {
    ...mapGetters('cart', ['products']),
    modalId() {
      return 'denomination_modal' + this.index;
    },

    denominationeData() {
      return this.products[this.index].denomination;
    },

    //暫存資料
    temp() {
      return this.products[this.index].TempSave;
    },

    enjoyDis() {
      return _.get(this.denominationeData, 'DiscAmnt', 0);
    },

    parseEnjoyDis() {
      return parseInt(this.enjoyDis) || 0;
    },

    bonusDis() {
      return this.temp.bonusDis;
    },
    parseBonusDis() {
      return parseInt(this.bonusDis) || 0;
    },
    couponDis() {
      return this.temp.couponDis;
    },
    parseCouponDis() {
      return parseInt(this.couponDis) || 0;
    }
  },

  methods: {
    ...mapMutations('cart', ['setCartProductsDiscount']),
    handleHide() {
      this.$refs.modal.hide();
      this.$bvModal.show('discoupon_modal' + this.index);
    },

    calculate() {
      //總抵扣金額
      let minusAmount =
        this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis;

      //總金額
      let totalPrice = this.product.price * this.product.quantity;

      //實付金額
      let payPrice = this.product.price * this.product.quantity - minusAmount;

      if (payPrice < 0) {
        if (totalPrice - this.parseBonusDis < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (totalPrice - (this.parseBonusDis + this.parseEnjoyDis) < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (
          totalPrice -
            (this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis) <
          0
        ) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }
        return;
      }

      //資料存進vuex
      this.setCartProductsDiscount({
        index: this.index,
        enjoyDis: this.enjoyDis,
        minusAmount: minusAmount,
        payPrice: payPrice,
        SkuNo30: this.denominationeData.Skuno,
        ReturnSkuNo30: this.denominationeData.ReturnSkuno,
        DiscType30: this.denominationeData.DiscType,
        Grno30: this.denominationeData.Grno,
        rebateName30: this.denominationeData.RebateName,
        accountType: 1,
        bonusDis: this.temp.bonusDis,
        RbonusPoints: this.temp.RbonusPoints,
        bonusDefaultNum: this.temp.bonusDefaultNum,
        couponDis: this.temp.couponDis,
        ticketNo: this.temp.ticketNo,
        EventMastId: this.temp.EventMastId,
        EventDetlId: this.temp.EventDetlId,
        DESCRITPION: this.temp.DESCRITPION,
        DiscTypePoint: this.temp.DiscTypePoint,
        DscSku: this.temp.DscSku,
        SkuNoPoint: this.temp.SkuNoPoint,
        copu_type: this.temp.copu_type,
        SkuNo10: this.temp.SkuNo10,
        ReturnSkuNo10: this.temp.ReturnSkuNo10,
        DiscType10: this.temp.DiscType10,
        Grno10: this.temp.Grno10,
        rebateName10: this.temp.rebateName10
      });
    },

    submit() {
      this.calculate();
      this.$refs.modal.hide();
    }
  }
};
</script>
